const start_state = {
  active: null,
};

const initial_state = {
  FIRST_3D: start_state,
  FIRST_SELECT: start_state,
  FIRST_FLOODING: start_state,
  FIRST_FLOODING_ZOOM_IN: start_state,
  FIRST_HEX: start_state,
  FIRST_HOVER: start_state,
  FILTER_HOVER: start_state,
  FIRST_RRR: start_state,
};

export default initial_state;
